import { Anchor, Info, Mail, MessageCircle, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

const CONTACT_EMAIL = "constantinguisembert4@gmail.com";
const COMMUNITY = {
  whatsapp: "https://chat.whatsapp.com/IGrJoS8cVpMDUnCSRX1Cty",
  facebook: "https://www.facebook.com/groups/1486535932408118",
};

export default function Footer() {
  return (
    <footer className="bg-ocean text-blanc/90 mt-16">
      <div className="max-w-6xl mx-auto px-6 py-10 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2.5 mb-3">
            <img src="/le-bon-matelot-logo.png" alt="Le Bon Matelot"
                 className="w-10 h-10 rounded-full object-cover ring-2 ring-blanc/20" />
            <span className="font-display text-lg font-bold">Le Bon Matelot</span>
          </div>
          <p className="text-sm text-blanc/70 leading-relaxed">
            La communauté bretonne de pêcheurs qui partagent leurs sorties en mer.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-blanc/60 mb-3 font-bold">Naviguer</h4>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/explorer" className="hover:text-blanc">Sorties disponibles</Link></li>
            <li><Link to="/publier" className="hover:text-blanc">Proposer une sortie</Link></li>
            <li><Link to="/mon-espace" className="hover:text-blanc">Mon espace</Link></li>
            <li><Link to="/faq" className="hover:text-blanc">FAQ</Link></li>
            <li><Link to="/confiance" className="hover:text-blanc">Badge de confiance</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-blanc/60 mb-3 font-bold">Communauté</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a data-testid="footer-whatsapp" href={COMMUNITY.whatsapp} target="_blank" rel="noopener noreferrer"
                 className="inline-flex items-center gap-2 hover:text-blanc">
                <MessageCircle className="w-4 h-4" /> Groupe WhatsApp
              </a>
            </li>
            <li>
              <a data-testid="footer-facebook" href={COMMUNITY.facebook} target="_blank" rel="noopener noreferrer"
                 className="inline-flex items-center gap-2 hover:text-blanc">
                <Facebook className="w-4 h-4" /> Groupe Facebook
              </a>
            </li>
            <li>
              <a data-testid="footer-contact" href={`mailto:${CONTACT_EMAIL}`}
                 className="inline-flex items-center gap-2 hover:text-blanc">
                <Mail className="w-4 h-4" /> Contact
              </a>
            </li>
          </ul>
        </div>

        <div className="bg-blanc/8 border border-blanc/15 rounded-2xl p-4">
          <h4 className="text-xs uppercase tracking-widest text-blanc/70 mb-2 font-bold inline-flex items-center gap-1.5">
            <Info className="w-3.5 h-3.5" /> Aucun paiement sur la plateforme
          </h4>
          <p className="text-xs text-blanc/75 leading-relaxed">
            Le Bon Matelot est une plateforme de mise en relation entre passionnés de pêche.
            <strong className="text-blanc"> Aucun paiement n'est réalisé sur la plateforme.</strong>
            {" "}La participation aux frais est indicative et se règle directement entre les membres.
          </p>
        </div>
      </div>
      <div className="border-t border-blanc/10">
        <div className="max-w-6xl mx-auto px-6 py-4 text-xs text-blanc/60 flex flex-col md:flex-row md:justify-between gap-1.5">
          <span>© {new Date().getFullYear()} Le Bon Matelot</span>
          <span>Fait en Bretagne · Bréhec · Paimpol · Saint-Quay · Erquy</span>
        </div>
      </div>
    </footer>
  );
}
